import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const StyledDealCardContainer = styled(Flex)<FlexProps>`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.25rem;
`;

export const InPageNavValuationsHeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const ValuationsHomeContainer = styled.div`
	margin: 0;
	flex: 1;
	overflow: auto;
`;
